module.exports = __webpack_public_path__ + "static/media/vacunar.09d6fc81.jpg";